import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "../../../utils/translation";
import {
  createBusinessByAdmin,
  listBusinesses,
  selectBusinessesCreateError,
  selectBusinessesCreateLoading,
  selectBusinessesCreateMessage,
} from "../businessSlice";

const BusinessCreatePage = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const createLoading = useSelector(selectBusinessesCreateLoading);
  const adminAccess = useSelector((state) => state.auth?.adminAccess);
  const createError = useSelector(selectBusinessesCreateError);
  const createMessage = useSelector(selectBusinessesCreateMessage);
  const [successMessage, setSuccessMessage] = useState("");
  const [permissionError, setPermissionError] = useState("");
  const [formState, setFormState] = useState({
    businessName: "",
    businessMail: "",
    businessState: true,
  });

  const handleChange = (event) => {
    const { name, value, type, checked } = event.target;
    setFormState((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const handleSubmit = async () => {
    if (!adminAccess) {
      setPermissionError(t("admin_common.permission_denied"));
      return;
    }
    setSuccessMessage("");
    setPermissionError("");
    const payload = {
      businessName: formState.businessName?.trim() || "",
      businessMail: formState.businessMail?.trim() || "",
      businessState: Boolean(formState.businessState),
    };
    if (!payload.businessName) return;
    try {
      await dispatch(createBusinessByAdmin(payload)).unwrap();
      await dispatch(listBusinesses());
      setFormState({ businessName: "", businessMail: "", businessState: true });
      setSuccessMessage(t("admin_business_pages.create_success_message"));
    } catch (error) {
      // Error is handled in slice state
    }
  };

  return (
    <div className="row">
      <div className="col-12">
        <div className="card">
          <div className="card-body">
            <h4 className="card-title">{t("admin_business_pages.create_title")}</h4>
            {permissionError && (
              <div className="alert alert-danger">{permissionError}</div>
            )}
            {successMessage && (
              <div className="alert alert-success">{successMessage}</div>
            )}
            {createError && (
              <div className="text-danger mb-2">
                {createMessage || t("admin_business_pages.create_failed")}
              </div>
            )}
            <div className="form-group mb-3">
              <label className="text-black font-w500">{t("admin_business_pages.name_label")}</label>
              <input
                type="text"
                className="form-control"
                name="businessName"
                value={formState.businessName}
                onChange={handleChange}
                placeholder={t("admin_business_pages.name_label")}
              />
            </div>
            <div className="form-group mb-3">
              <label className="text-black font-w500">{t("admin_business_pages.email_label")}</label>
              <input
                type="email"
                className="form-control"
                name="businessMail"
                value={formState.businessMail}
                onChange={handleChange}
                placeholder={t("admin_business_pages.email_label")}
              />
            </div>
            <div className="form-check form-switch mb-3">
              <input
                className="form-check-input"
                type="checkbox"
                id="business-create-active"
                name="businessState"
                checked={Boolean(formState.businessState)}
                onChange={handleChange}
              />
              <label className="form-check-label" htmlFor="business-create-active">
                {formState.businessState ? t("admin_common.status_active") : t("admin_common.status_passive")}
              </label>
            </div>
            <button
              type="button"
              className="btn btn-success"
              onClick={handleSubmit}
              disabled={createLoading}
            >
              {t("admin_common.save")}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BusinessCreatePage;
